<template>
  <div class="post_position">
    <div class="content_box">
      <el-form :hide-required-asterisk="true" :model="info_form" :rules="rules" ref="infoForm" label-width="110px" class="demo-info_form">
        <div class="title">职位基本信息</div>
        <div class="tip">职位发布成功后，招聘类型、职位名称、职位类型、工作城市，将无法修改</div>
        <el-form-item label="公 司">
        {{ companyName }}
        </el-form-item>
        <el-form-item label="招聘类型" prop="recruitment_type">
          <el-radio-group v-model="info_form.recruitment_type" @change="changeRecruitmentType">
            <el-radio-button v-for="system in typeOption" :key="system.value" :label="system.value">{{ system.label }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="职位名称" prop="name">
          <div class="input_box_position">
            <el-input maxlength="20" show-word-limit style="width: 540px;" @blur="closePanel" @focus="showPanel" v-model="info_form.name" placeholder="请填写职位名称，如'销售专员'"></el-input>
            <el-cascader-panel ref="cascaderRef" @change="getSelect" v-show="cascaderShow" v-model="info_form.name_value" class="panel" :options="zymcOption"></el-cascader-panel>
          </div>
        </el-form-item>
        <el-form-item label="职位描述" prop="position_introduction">
          <div class="textarea_box">
            <el-input @blur="input_text" style="width: 540px;" type="textarea" maxlength="1000" show-word-limit autosize placeholder="业务模式，公司规模等" v-model="info_form.position_introduction">
            </el-input>
            <div class="select_button">可选标题： <div class="button" @click="addDesc('岗位职责:')">岗位职责</div>
              <div class="button" @click="addDesc('任职要求:')">任职要求</div>
              <div class="button" @click="addDesc('岗位福利:')">岗位福利</div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="职位类型" prop="position_type">
          <div class="positionType_box" @click="openDialog" :style="{color:info_form.position_type?'':'#D1D4DC'}">{{ info_form.position_type?info_form.position_type :'选择职位类型' }}</div>
        </el-form-item>
        <div class="title">职位要求</div>
        <div class="tip">我们将通过以下条件，为您精确推荐合适的牛人，请尽量详细填写</div>
        <el-form-item label="经验" prop="experience_type">
          <el-select :popper-append-to-body='false' class="elSelect" v-model="info_form.experience_type" placeholder="请选择">
            <el-option v-for="item in exp_option" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学历" prop="degree">
          <el-select :popper-append-to-body='false' class="elSelect" v-model="info_form.degree" placeholder="请选择">
            <el-option v-for="item in education_option" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算方式" prop="payment_method" v-if="info_form.recruitment_type==4">
          <el-select :popper-append-to-body='false' v-model="info_form.payment_method" placeholder="请选择">
            <el-option v-for="item in paymentOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="薪资范围">
          <SelectSalaryComonent ref="salaryRef" :recruitment_type="info_form.recruitment_type" :salary_max="info_form.salary_max" :salary_min="info_form.salary_min" :salary_month="info_form.salary_month"
            :salary_unit="info_form.salary_unit" />
        </el-form-item>
        <el-form-item label="工作地点" prop="address_id">
          <el-select :popper-append-to-body='false' v-model="info_form.address_id" placeholder="请选择地址" @visible-change="openAddressSelect" @change="getDetialAddress">
            <el-option v-for="item in work_location" :key="item.id" :label="item.province+item.city+item.district+item.address" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="毕业时间" v-if="info_form.recruitment_type==2">
          <GraduationTime ref="graduationRef" :graduation_end_year="info_form.graduation_end_year" :graduation_start_year="info_form.graduation_start_year" />
        </el-form-item>
        <el-form-item label="招聘截止时间(选填)" v-if="info_form.recruitment_type==2">
          <el-date-picker popper-class="date-style" :picker-options="pickerOptions" value-format="yyyy-MM-dd" v-model="info_form.recruitment_deadline_date" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="兼职时间" prop="show_part_time" v-if="info_form.recruitment_type==4">
          <div class="positionType_box" @click="openTimeDialog" :style="{color:info_form.show_part_time?'':'#D1D4DC'}">{{ info_form.show_part_time?info_form.show_part_time :'选择兼职时间' }}</div>
        </el-form-item>
        <el-form-item label="招聘截止时间" prop="recruitment_deadline_date" v-if="info_form.recruitment_type==4">
          <el-date-picker popper-class="date-style" :picker-options="pickerOptions" value-format="yyyy-MM-dd" v-model="info_form.recruitment_deadline_date" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item v-if="info_form.recruitment_type==3" label="实习要求" prop="internship_month">
          <div style="display: flex; align-items: center;">
            <el-select :popper-append-to-body='false' style="margin-right: 15px;" v-model="info_form.internship_month" placeholder="最少实习月数" @visible-change="openAddressSelect">
              <el-option v-for="item in 12" :key="item" :label="item+'个月'" :value="item">
              </el-option>
            </el-select>
            <el-form-item prop="internship_workdays_per_week">
              <el-select :popper-append-to-body='false' v-model="info_form.internship_workdays_per_week" placeholder="最少周到岗天数" @visible-change="openAddressSelect">
                <el-option v-for="item in 7" :key="item" :label="item+'天'" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form-item>

      </el-form>
      <div class="footer_box">
        <el-button @click="publishJob('infoForm')">发布</el-button>
      </div>

    </div>
    <OccupationDialog @getThirdValue="getThirdValue" :value="showDialog" :name="info_form.name" :desc="info_form.position_introduction" @closeDialog="closeDialog" />
    <PartTimeJobTimeDialog :value="showTimeDialog" :part_time_hours="info_form.part_time_hours" @getPartTime="getPartTime" @closeDialog="closeTimeDialog"></PartTimeJobTimeDialog>
  </div>
</template>

<script>
import zymc from "../../../utils/zymc.json";
import SelectSalaryComonent from "../../../components/companyModule/SelectSalaryComonent.vue";
import OccupationDialog from "../../../components/companyModule/OccupationDialog.vue";
import PartTimeJobTimeDialog from "../../../components/companyModule/PartTimeJobTimeDialog.vue";
import GraduationTime from "../../../components/companyModule/GraduationTime.vue";
import { companyAddress } from "../../../utils/api";

export default {
  name: "",
  data() {
    return {
      info_form: {
        id: "",
        recruitment_type: 1,
        name: "", //职位名称
        name_value: null,
        position_introduction: "", ///职位描述
        experience_type: null,
        position_type: null, //职位类型
        position_type_value: [],
        address_id: null,
        address: "",
        province: "",
        city: "",
        district: "",
        recruitment_deadline_date: null,
        part_time_hours: {},
        payment_method: null,
        show_part_time: null,
        salary_min: null,
        salary_max: null,
        degree: "",
        graduation_end_year: null,
        graduation_start_year: null,
        salary_month: null,
        salary_unit: null,
        internship_workdays_per_week: null,
        internship_month: null,
      },
      rules: {
        recruitment_type: [
          { required: true, message: "请选择招聘类型", trigger: "change" },
        ],
        name: [
          { required: true, message: "请选择职位名称", trigger: "change" },
        ],
        position_introduction: [
          { required: true, message: "请输入职位描述", trigger: "blur,change" },
        ],
        position_type: [
          { required: true, message: "请选择职位类型", trigger: "change" },
        ],
        experience_type: [
          { required: true, message: "请选择经验", trigger: "change" },
        ],
        degree: [{ required: true, message: "请选择学位", trigger: "change" }],
        payment_method: [
          { required: true, message: "请选择结算方式", trigger: "change" },
        ],
        address_id: [
          { required: true, message: "请选择工作地点", trigger: "change" },
        ],
        graduation_start_year: [
          { required: true, message: "请选择毕业时间", trigger: "change" },
        ],
        recruitment_deadline_date: [
          {
            required: true,
            message: "请选择招聘截止时间",
            trigger: "change",
          },
        ], //选填/必填
        show_part_time: [
          { required: true, message: "请选择兼职时间", trigger: "change" },
        ],
        internship_month: [
          { required: true, message: "最少实习月数", trigger: "change" },
        ],
        internship_workdays_per_week: [
          { required: true, message: "最少周到岗天数", trigger: "change" },
        ],
      },
      typeOption: [
        {
          label: "社招全职",
          value: 1,
        },
        {
          label: "应届校园招聘",
          value: 2,
        },
        {
          label: "实习生招聘",
          value: 3,
        },
        {
          label: "兼职招聘",
          value: 4,
        },
      ],
      exp_option: [],
      experienceOption: [
        {
          label: "不限",
          value: 1,
        },
        {
          label: "1年以内",
          value: 5,
        },
        {
          label: "1-3年",
          value: 6,
        },
        {
          label: "3-5年",
          value: 7,
        },
        {
          label: "5-10年",
          value: 8,
        },
        {
          label: "10年以上",
          value: 9,
        },
      ],
      experience_option: [{ label: "在校/应届", value: "2,3" }],
      education_option: [
        { label: "不限", value: "不限" },
        { label: "初中及以下", value: "初中及以下" },
        { label: "中专/中技", value: "中专/中技" },
        { label: "高中", value: "高中" },
        { label: "大专", value: "大专" },
        { label: "本科", value: "本科" },
        { label: "硕士", value: "硕士" },
        { label: "博士", value: "博士" },
      ],
      paymentOption: [
        {
          label: "日结",
          value: 1,
        },
        {
          label: "周结",
          value: 2,
        },
        {
          label: "月结",
          value: 3,
        },
        {
          label: "完工结",
          value: 4,
        },
      ],
      min_salary: [],
      max_salary: [],
      work_location: [],
      zymcOption: zymc,
      cascaderShow: false,
      showDialog: false,
      showTimeDialog: false,
      pickerOptions: {
        disabledDate(time) {
          const date = new Date();
          date.setDate(date.getDate() - 1);
          console.log(time.getTime() < date.getTime());
          return time.getTime() < date.getTime();
          // return time.getTime() > Date.now()
        },
      },
      show_part_time: "",
      companyName: "",
    };
  },
  components: {
    OccupationDialog,
    SelectSalaryComonent,
    GraduationTime,
    PartTimeJobTimeDialog,
  },
  mounted() {
    this.getAddress();
    if (this.$route.query.id) {
      this.getPositionDetial();
    } else {
      this.reset();
    }
    this.getCompanyDetial();
  },
  methods: {
    showPanel() {
      if (this.info_form.name) {
        this.cascaderShow = false;
      } else {
        this.cascaderShow = true;
      }
    },
    closePanel() {
      this.showPanel();
      if (this.info_form.name != this.info_form.position_type) {
        this.info_form.position_type = "";
      }
    },
    getSelect() {
      this.info_form.name = this.$refs.cascaderRef.getCheckedNodes()[0].label;
      this.info_form.position_type =
        this.$refs.cascaderRef.getCheckedNodes()[0].label;
      this.cascaderShow = false;
      this.$refs.infoForm.clearValidate("position_type");
    },
    openDialog() {
      if (!this.info_form.name.trim()) {
        this.$message.warning("请先添加职位名称");
        return;
      }
      if (!this.info_form.position_introduction.trim()) {
        this.$message.warning("请先添加职位描述");
        return;
      }
      this.showDialog = true;
    },
    closeDialog() {
      this.showDialog = false;
    },
    getThirdValue(val) {
      console.log(val, "ppp");

      this.info_form.position_type = val.label;
      this.$refs.infoForm.clearValidate("position_type");
    },
    addDesc(desc) {
      if (this.info_form.position_introduction) {
        this.info_form.position_introduction = `${this.info_form.position_introduction}
${desc}`;
      } else {
        this.info_form.position_introduction = `${desc}`;
      }
      this.$refs.infoForm.clearValidate("position_introduction");
    },
    input_text() {
      console.log(
        "this.info_form.position_introduction",
        this.info_form.position_introduction
      );
    },
    changeRecruitmentType(val) {
      //   this.$refs.infoForm.resetFields();
      this.info_form.recruitment_type = val;

      this.reset(val);
      this.$refs.infoForm.clearValidate();
    },
    reset(val) {
      if (
        this.info_form.recruitment_type == 1 ||
        this.info_form.recruitment_type == 4
      ) {
        this.exp_option = this.experienceOption;
        // this.info_form.experience_type = null;
      } else {
        this.exp_option = this.experience_option;
        this.info_form.experience_type = "2,3";
      }
    },
    // init(){
    //     this.info_form.name=""
    // },
    getAddress() {
      this.$httpcompany.axiosGet(this.$api.companyAddress, (res) => {
        if (res.code == 200) {
          this.work_location = res.data ? res.data : [];
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    openAddressSelect(val) {
      if (val) {
        if (this.work_location.length == 0) {
          this.$message.warning("请先添加地址");
        }
      }
    },
    getDetialAddress(val) {
      let obj = this.work_location.find((item) => item.id == val);
      this.info_form.address = obj.address;
      this.info_form.city = obj.city;
      this.info_form.district = obj.district;
      this.info_form.province = obj.province;
    },
    openTimeDialog() {
      this.showTimeDialog = true;
    },
    closeTimeDialog() {
      this.showTimeDialog = false;
    },
    getPartTime(val) {
      console.log(val);

      Object.assign(this.info_form.part_time_hours, val);
      this.info_form.show_part_time = `工作日期:${
        val.working_dates
      };工作时间段:${val.working_time_period};每周工作天数:${
        val.workdays_per_week
      };工作时间:${
        val.working_hours.type == 3 ? "不限时间" : val.working_hours.time
      };`;
      this.showTimeDialog = false;
      this.$refs.infoForm.clearValidate("show_part_time");
    },
    publishJob(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.info_form);
          console.log(
            "this.$refs.salaryRef.salary_form",
            this.$refs.salaryRef.salary_form
          );
          let params = {};
          Object.assign(params, this.info_form);
          if (!this.$refs.salaryRef.salary_form.min_value) {
            this.$message.warning("请输入薪资范围！");
            return;
          }
          if (!this.$refs.salaryRef.salary_form.max_value) {
            this.$message.warning("请输入最低月薪！");
            return;
          }
          params.salary_min = this.$refs.salaryRef.salary_form.min_value;
          params.salary_max = this.$refs.salaryRef.salary_form.max_value;
          switch (this.info_form.recruitment_type) {
            case 1:
              // 社会全招
              params.salary_min =
                this.$refs.salaryRef.salary_form.min_value * 1000;
              params.salary_max =
                this.$refs.salaryRef.salary_form.max_value * 1000;
              params.salary_month =
                this.$refs.salaryRef.salary_form.salary_unit;
              break;
            case 2:
              if (
                !(
                  this.$refs.graduationRef.start_year &&
                  this.$refs.graduationRef.start_year
                )
              ) {
                this.$message.warning("请输入毕业时间！");
                return;
              }
              // 应届校园 招聘
              params.salary_month =
                this.$refs.salaryRef.salary_form.salary_unit;
              params.graduation_start_year =
                this.$refs.graduationRef.start_year;
              params.graduation_end_year = this.$refs.graduationRef.start_year;
              params.salary_min =
                this.$refs.salaryRef.salary_form.min_value * 1000;
              params.salary_max =
                this.$refs.salaryRef.salary_form.max_value * 1000;
              params.salary_month =
                this.$refs.salaryRef.salary_form.salary_unit;

              break;
            case 3:
              // 实习生招聘

              break;
            case 4:
              // 兼职招聘
              params.salary_unit = this.$refs.salaryRef.salary_form.salary_unit;
              break;
          }

          this.$httpcompany.axiosPost(
            this.$api.positionManageSavePosition,
            params,
            (res) => {
              if (res.code == 200) {
                // 发布成功
                this.$message({
                  type: "success",
                  message: res.message,
                });
                this.$router.push("/company/recruitment/management");
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            }
          );
          // 校验薪资
          //
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      this.$refs.salaryRef.checkSalary();
    },
    getPositionDetial() {
      //
      this.$httpcompany.axiosGetBy(
        this.$api.positionManagePositionDetail,
        { id: Number(this.$route.query.id) },
        (res) => {
          if (res.code == 200) {
            // 发布成功
            Object.assign(this.info_form, res.data);
            this.info_form.experience_type = Number(
              this.info_form.experience_type
            );
            this.info_form.payment_method = this.info_form.payment_method
              ? this.info_form.payment_method
              : null;
            this.info_form.internship_month = this.info_form.internship_month
              ? this.info_form.internship_month
              : null;
            this.info_form.internship_workdays_per_week = this.info_form
              .internship_workdays_per_week
              ? this.info_form.internship_workdays_per_week
              : null;
            this.reset();
            if (this.info_form.recruitment_type == 4) {
              this.info_form.show_part_time = `工作日期:${
                this.info_form.part_time_hours.working_dates
              };工作时间段:${
                this.info_form.part_time_hours.working_time_period
              };每周工作天数:${
                this.info_form.part_time_hours.workdays_per_week
              };工作时间:${
                this.info_form.part_time_hours.working_hours.type == 3
                  ? "不限时间"
                  : this.info_form.part_time_hours.working_hours.time
              };`;
            }
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        }
      );
    },
    getCompanyDetial() {
      this.$httpcompany.axiosGet(this.$api.companyDetail, (res) => {
        if (res.code == 200) {
          this.companyName = res.data.name?res.data.name:"暂无公司名称";
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.post_position {
  width: 100%;
  padding: 20px 160px;
  box-sizing: border-box;
  .content_box {
    background: #ffffff;
    border-radius: 12px 12px 12px 12px;
    padding: 40px;
    box-sizing: border-box;
    .title {
      font-weight: 400;
      font-size: 18px;
      color: #222223;
      margin-bottom: 5px;
    }
    .tip {
      font-weight: 400;
      font-size: 12px;
      color: #8d97a7;
      margin-bottom: 35px;
    }
  }
  .footer_box {
    .el-button {
      width: 86px;
      height: 34px;
      background: #685ef5;
      border-radius: 4px 4px 4px 4px;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
.textarea_box {
  position: relative;
  :deep(.el-textarea__inner) {
    padding-top: 36px;
  }
  .select_button {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    padding: 0px 15px;
    box-sizing: border-box;
    font-size: 12px;
    color: #8d97a6;
    .button {
      width: 64px;
      height: 24px;
      background: #f0f2f5;
      border-radius: 12px;
      font-size: 12px;
      color: #363e4d;
      line-height: 24px;
      display: inline-block;
      text-align: center;
      user-select: none;
      margin-right: 6px;
      cursor: pointer;
    }
  }
}
.positionType_box {
  width: 540px;
  min-height: 40px;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #e3e7ee;
  line-height: 40px;
  padding-left: 15px;
  box-sizing: border-box;
  cursor: pointer;
  &:hover {
    border-color: #685ef5;
  }
}
.input_box_position {
  width: 540px;

  position: relative;
  .panel {
    position: absolute;
    top: 40px;
    left: 0px;
    z-index: 100000;
    ::v-deep .in-active-path {
      color: #685ef5;
    }
    ::v-deep .is-active {
      color: #685ef5;
    }
  }
}
::v-deep .el-cascader-menu__wrap {
  background: #fff;
  height: 300px;
}
.el-radio-button {
  margin-right: 12px;
  margin-bottom: 12px;
  background: #ffffff;
  ::v-deep .el-radio-button__inner {
    border: 1px solid #e6e8eb;
    border-radius: 4px 4px 4px 4px;
    font-weight: 500;
    font-size: 14px;
    color: #313640;
    box-shadow: none;
  }
}
.el-radio-button.is-checked {
  background: #dedbff;
  ::v-deep .el-radio-button__inner {
    border: 1px solid #685ef5;
    color: #685ef5;
    background: #dedbff;
    box-shadow: none;
    position: relative;
  }
}
.el-radio-button.is-checked .el-radio-button__inner {
}

::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #f2f2ff;
  border-radius: 4px 4px 4px 4px;
  color: #685ef5;
  // border: 1px solid #685ef5;
}
::v-deep .el-textarea__inner {
  height: 196px !important;
  &:focus {
    border-color: #685ef5 !important;
  }
}
::v-deep .el-input__inner:focus {
  border-color: #685ef5 !important;
}

::v-deep .el-select-dropdown__item.selected {
  color: #685ef5;
}
</style>
